import React from 'react';
import Covenant from '../components/Covenant';

function CovenantPage() {
  return <Covenant />;
}

export default CovenantPage;
